<template>
  <div class="pages">
    <div class="filter">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="选择日期">
            <el-date-picker
              v-model="formInline.dateValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
            <el-select
              clearable
              v-model="formInline.School"
              placeholder="请选择学校"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="关键字">
            <el-input
              v-model="formInline.keyWord"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searcList">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table">
      <el-button type="primary" size="medium" @click="dialogFormVisible = true"
        >添加敏感词</el-button
      >
      <el-table :data="tableData" height="5.34rem" max-height="5.34rem">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <!-- <el-table-column property="school" label="所属学校" align="center">
        </el-table-column> -->
        <el-table-column property="word" label="屏蔽词" align="center">
        </el-table-column>
        <el-table-column
          property="creationTime"
          label="创建时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="hitCount"
          label="近30天命中次数"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="del(scope.row)"
              type="text"
              style="color: #f00"
              size="medium"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加敏感词"
      :destroy-on-close="true"
      width="30%"
      :visible.sync="dialogFormVisible"
      @close="close"
    >
      <el-form>
        <!-- <el-form-item label="学校">
          <el-select
            style="width: 80%;"
            clearable
            v-model="sensitiveSchool"
            placeholder="请选择学校"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="内容">
          <el-input
            style="width: 80%;"
            type="textarea"
            v-model="sensitiveWord"
            maxlength="20"
            show-word-limit
          ></el-input>
          <p>单个敏感词不得超过20个字符</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addArticleFilter">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      schoolList: [],
      dialogFormVisible: false,
      tableData: [],
      formInline: {
        School: "",
        dateValue: "",
        keyWord: ""
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //敏感词
      sensitiveWord: "",
      sensitiveSchool: ""
    };
  },
  created() {
    this.getArticleFilterList();
    this.getSchoolList();
  },
  mounted() {},
  methods: {
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    searcList() {
      this.currentPage = 1;
      this.getArticleFilterList(this.currentPage);
    },
    //获取信息列表
    getArticleFilterList(pageIndex = 1, pageSize = 10) {
      var query = {
        pageIndex: pageIndex,
        pageSize: pageSize,
        School: this.formInline.School ? this.formInline.School : null,
        DateBegin:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[0],
        DateEnd:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[1],
        Keyword: this.formInline.keyWord
      };
      var url = this.$dataConver.getUrl(
        "/admin/ArticleFilter/GetArticleFilterList",
        query
      );
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          if (this.currentPage > 1 && this.tableData.length <= 0) {
            this.getArticleFilterList(--this.currentPage);
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    del(val) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteArticleFilter(val.id);
        })
        .catch(() => {});
    },
    //添加敏感词
    addArticleFilter() {
      if (this.$dataConver.isNull(this.sensitiveWord)) {
        this.$message.error("请输入要屏蔽的敏感词！");
        return false;
      }
      // if (this.$dataConver.isNull(this.sensitiveSchool)) {
      //   this.$message.error("请选择学校！");
      //   return false;
      // }
      this.$api
        .post("/admin/ArticleFilter/AddArticleFilter", {
          id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          word: this.sensitiveWord,
          // schoolId: this.sensitiveSchool,
          creationTime: "2022-07-20T06:26:51.206Z"
        })
        .then(res => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.close();
            this.currentPage = 1;
            this.getArticleFilterList(this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //删除敏感词
    deleteArticleFilter(id) {
      this.$api
        .post("/admin/ArticleFilter/DeleteArticleFilter?id=" + id)
        .then(res => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.getArticleFilterList(this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    close() {
      this.sensitiveWord = "";
      this.sensitiveSchool = "";
      this.dialogFormVisible = false;
      this.formInline = {
        dateValue: "",
        keyWord: ""
      };
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.getArticleFilterList(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getArticleFilterList(this.currentPage, this.currentSize);
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  margin-top: 0.3rem;
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/contentManagement/contentFiltering.vue